import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import store from "@/stores";
import vuetify from "@/plugins/vuetify";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";

import i18n from "@/core/plugins/vue-i18n";

import * as ElementPlusIconsVue from "@element-plus/icons-vue";

// Style
import "@/assets/style/style.scss";
import "@/scss/style.scss";

import { PerfectScrollbarPlugin } from "vue3-perfect-scrollbar";

import createLoadingPlugin from "@/core/plugins/loading";

const app = createApp(App);
app.use(router);
app.use(store);
app.use(ElementPlus);
app.use(PerfectScrollbarPlugin);
app.use(createPinia());
app.use(vuetify);
app.use(i18n);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// Install the loading plugin
app.use(createLoadingPlugin());

app.mount("#app");
